// Check if a date is same as today's date
export const isToday = (date: Date | string) => {
  const today = new Date();

  if (typeof date === "string" && !isValidDateString(date)) {
    return false;
  }

  date = new Date(date);

  return (
    date.getFullYear() === today.getFullYear() &&
    date.getMonth() === today.getMonth() &&
    date.getDate() === today.getDate()
  );
};

// Check if a string is a valid date string
export const isValidDateString = (date: string) => {
  return !isNaN(new Date(date).getDate());
};

export function diffInMilliseconds(date1: Date, date2: Date) {
  const diffInMilliseconds = Math.abs(date1.getTime() - date2.getTime());

  return diffInMilliseconds;
}

export function diffInSeconds(date1: Date, date2: Date) {
  const diff = diffInMilliseconds(date1, date2);

  return Math.floor(diff / 1000);
}

export function diffInMinutes(date1: Date, date2: Date) {
  const diff = diffInMilliseconds(date1, date2);

  return Math.floor(diff / 1000 / 60);
}

// Formats a date string into a human-readable date (e.g., "January 1, 2024")
export const formatToLongDate = (dateString: string) => {
  return new Date(dateString).toLocaleDateString(undefined, {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
};

// Formats a date string into a 24-hour time (e.g., "14:30")
export const formatTo24HourTime = (date: Date | string, timeZone?: string) => {
  if (!date) return "Invalid date";

  if (typeof date === "string") {
    if (!isValidDateString(date)) return "Invalid date";
  }

  // console.log("Formatting date:", date, "with timeZone:", timeZone);

  return new Intl.DateTimeFormat(undefined, {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
    timeZone: timeZone,
  }).format(new Date(date));
};
